<template>
    <v-container fluid class="h-100 dictionary-page">
        <v-row no-gutters class="h-100">
                <v-col
                        cols="12"
                        md="6"
                        lg="6"
                        xl="6"
                        class="h-100">
                    <v-card class="card-container">
                        <v-card-title style="padding: 0;">
                            <div class="car-header">
                                <div class="car-header-title">Марки <span class="car-header-subtitle"> {{filteredMarks.length}}</span>
                                </div>
                                <v-divider/>
                                <div class="car-header-toolbar">
                                    <div class="car-header-toolbar_add-btn">
                                        <v-btn
                                                dark
                                                dense
                                                color="var(--color-blue)"
                                                @click="showAddMarkModal"
                                        >
                                            <span class="btn-text"> <v-icon dark>add</v-icon> Добавить марку</span>
                                        </v-btn>
                                    </div>
                                    <div class="car-header-toolbar_search-block">
                                            <v-text-field
                                                    class=" search-block"
                                                    v-model="searchMark"
                                                    prepend-inner-icon="mdi-magnify"
                                                    single-line
                                                    color="var(--color-blue)"
                                                    solo
                                                    dense
                                                    hide-details
                                                    placeholder="Поиск"
                                            />

                                    </div>
                                </div>
                                <v-divider/>
                            </div>
                        </v-card-title>
                        <v-card-text style="padding: 0; overflow-y: scroll">
                            <v-list flat>
                                <v-list-item-group
                                        v-model="selectedMark"
                                        active-class="selected-item"
                                >
                                    <v-list-item v-for="item in filteredMarks" @click="markSelect(item)" :key="item.id"  :value="item" selectable>
                                        <v-list-item-content>
                                            <v-list-item-title v-text="item.carMarkName"></v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-btn @click="showEditMarkModal" class="item-action" icon><v-icon>mdi-pencil</v-icon></v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-list-item-group>
                            </v-list>
                        </v-card-text>
                    </v-card>

                </v-col>
                <v-col
                        cols="12"
                        md="6"
                        lg="6"
                        xl="6"
                        class="h-100">
                    <v-card class="card-container">
                        <v-card-title style="padding: 0;">
                            <div class="car-header">
                                <div class="car-header-title">Модели {{selectedMark!=null?selectedMark.carMarkName:""}}<span class="car-header-subtitle"> {{filteredModels.length}}</span>
                                </div>
                                <v-divider/>
                                <div class="car-header-toolbar">
                                    <div class="car-header-toolbar_add-btn">
                                        <v-btn
                                                dark
                                                dense
                                                color="var(--color-blue)"
                                                @click="showAddModelModal"
                                        >
                                            <span class="btn-text"> <v-icon dark>add</v-icon> Добавить модель</span>
                                        </v-btn>
                                    </div>
                                    <div class="car-header-toolbar_search-block">
                                        <v-text-field
                                                class="search-block"
                                                v-model="searchModel"
                                                prepend-inner-icon="mdi-magnify"
                                                single-line
                                                color="var(--color-blue)"
                                                solo
                                                dense
                                                hide-details
                                                placeholder="Поиск"
                                        />
                                    </div>
                                </div>
                                <v-divider/>
                            </div>
                        </v-card-title >
                        <v-card-text style="padding: 0; overflow-y: scroll">
                            <v-list flat>
                                <v-list-item-group
                                        v-model="selectedModel"
                                        active-class="selected-item"

                                >
                                    <v-list-item @click="modelSelect(item)" :value="item" selectable v-for="item in filteredModels" :key="item.id">
                                        <v-list-item-content>
                                            <v-list-item-title v-text="">
                                                <v-row no-gutters>
                                                    <v-col>
                                                        {{item.carModelName}}
                                                    </v-col>
                                                    <v-col>
                                                        {{item.yearBeg +" - "+(item.yearEnd!=0?item.yearEnd:"Настоящее время")}}

                                                    </v-col>
                                                </v-row>
                                            </v-list-item-title>
                                        </v-list-item-content>
                                        <v-list-item-action>
                                            <v-btn @click="showEditModelModal" class="item-action" icon><v-icon>mdi-pencil</v-icon></v-btn>
                                        </v-list-item-action>
                                    </v-list-item>
                                </v-list-item-group>
                            </v-list>
                        </v-card-text>
                    </v-card>

                </v-col>
            </v-row>


        <b-modal
                id="modalAddMark"
                centered
                title="Добавление записи"
        >
            <b-container fluid>
                <b-row class="mb-1">

                    <b-col>
                        <label class="custom-input-label">Марка автомобиля</label>
                        <b-input
                                v-model="editCarMark.carMarkName"
                                required
                        />
                    </b-col>
                </b-row>
            </b-container>
            <template slot="modal-footer">
                <div class="w-100">
                    <v-row no-gutters  justify="space-between">

                        <v-spacer></v-spacer>
                        <v-col cols="auto" class="mr-2">
                            <v-btn
                                    color="var(--color-blue)"
                                    dark
                                    size="sm"
                                    @click="onSaveMark"
                            >
                                Сохранить
                            </v-btn>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn
                                    class="cancel-btn"
                                    outlined
                                    color="var(--color-3)"
                                    size="sm"
                                    @click="$bvModal.hide('modalAddMark')"
                            >
                                Отмена
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>

            </template>
        </b-modal>
        <b-modal
                id="modalEditMark"
                centered
                title="Редактирование записи"
        >
            <b-container fluid>
                <b-row class="mb-1">
                    <b-col>
                        <label class="custom-input-label">Марка автомобиля</label>
                        <b-input
                                v-model="editCarMark.carMarkName"
                                required
                        />
                    </b-col>
                </b-row>
            </b-container>
            <template slot="modal-footer">
                <div class="w-100">
                    <v-row no-gutters  justify="space-between">
                        <v-col cols="auto">
                            <v-btn
                                    outlined
                                    color="var(--color-red)"
                                    size="sm"
                                    @click="deleteMark"
                            >
                                <v-icon>mdi-delete</v-icon> Удалить
                            </v-btn>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="auto" class="mr-2">
                            <v-btn
                                   color="var(--color-blue)"
                                   dark
                                    size="sm"
                                    @click="onSaveMark"
                            >
                                Сохранить
                            </v-btn>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn
                                    class="cancel-btn"
                                    outlined
                                    color="var(--color-3)"
                                    size="sm"
                                    @click="$bvModal.hide('modalEditMark')"
                            >
                                Отмена
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>

            </template>
        </b-modal>

        <b-modal
                id="modalAddModel"
                centered
                title="Добавление новой записи"
        >
            <b-container fluid>
                <b-row
                        class="mb-1"
                        no-gutters
                >
                    <b-col>
                        <label class="custom-input-label">Марка</label>
                        <b-select
                                :options="allMarksItems"
                                v-model="editCarModel.carMarkId"
                                required
                                text-field="carMarkName"
                                value-field="id"
                        />
                    </b-col>
                </b-row>
                <b-row
                        class="mb-1"
                        no-gutters
                >
                    <b-col>
                        <label class="custom-input-label">Модель</label>
                        <b-input
                                v-model="editCarModel.carModelName"
                                required
                        />
                    </b-col>
                </b-row>

                <b-row
                        class="mb-1"
                        no-gutters
                        align-h="between"
                >
                    <b-col cols="12">
                        <label class="custom-input-label">Года выпуска</label>
                    </b-col>
                    <b-col >
                        <b-input
                                v-model="editCarModel.yearBeg"
                                min="0"
                                type="number"
                                required
                                placeholder="ОТ"
                        />
                    </b-col>
                    <b-col >
                        <b-input
                                v-model="editCarModel.yearEnd"
                                min="0"
                                type="number"
                                required
                                placeholder="ДО"
                        />
                    </b-col>
                    <b-col cols="12">
                        <span style="color:var(--color-2); font-weight: 500;font-size: 16px;line-height: 20px;">0 = Выпускается по нынешнее время </span>
                    </b-col>
                </b-row>
            </b-container>
            <template slot="modal-footer">
                <div class="w-100">
                    <v-row no-gutters  justify="space-between">

                        <v-spacer></v-spacer>
                        <v-col cols="auto" class="mr-2">
                            <v-btn
                                    color="var(--color-blue)"
                                    dark
                                    size="sm"
                                    @click="onSaveModel"
                            >
                                Сохранить
                            </v-btn>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn
                                    class="cancel-btn"
                                    outlined
                                    color="var(--color-3)"
                                    size="sm"
                                    @click="$bvModal.hide('modalAddModel')"
                            >
                                Отмена
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
            </template>
        </b-modal>
        <b-modal
                id="modalEditModel"
                centered
                title="Редактирование записи"
        >
            <b-container fluid>
                <b-row
                        class="mb-1"
                        no-gutters
                >
                    <b-col>
                        <label class="custom-input-label">Модель</label>
                        <b-select
                                :options="allMarksItems"
                                v-model="editCarModel.carMarkId"
                                required
                                text-field="carMarkName"
                                value-field="id"
                        />
                    </b-col>
                </b-row>
                <b-row
                        class="mb-1"
                        no-gutters
                >
                    <b-col>
                        <label class="custom-input-label">Модель</label>
                        <b-input
                                v-model="editCarModel.carModelName"
                                required
                        />
                    </b-col>
                </b-row>
                <b-row
                        class="mb-1"
                        no-gutters
                        align-h="between"
                >
                    <b-col cols="12">
                        <label class="custom-input-label">Года выпуска</label>
                    </b-col>
                    <b-col >
                        <b-input
                                v-model="editCarModel.yearBeg"
                                min="0"
                                type="number"
                                required
                                placeholder="ОТ"
                        />
                    </b-col>
                    <b-col >
                        <b-input
                                v-model="editCarModel.yearEnd"
                                min="0"
                                type="number"
                                required
                                placeholder="ДО"
                        />
                    </b-col>
                    <b-col cols="12">
                        <span style="color:var(--color-2); font-weight: 500;font-size: 16px;line-height: 20px;">0 = Выпускается по нынешнее время </span>
                    </b-col>
                </b-row>
            </b-container>
            <template slot="modal-footer">
                <div class="w-100">
                    <v-row no-gutters  justify="space-between">
                        <v-col cols="auto">
                            <v-btn
                                    outlined
                                    color="var(--color-red)"
                                    size="sm"
                                    @click="deleteModel"
                            >
                                <v-icon>mdi-delete</v-icon> Удалить
                            </v-btn>
                        </v-col>
                        <v-spacer></v-spacer>
                        <v-col cols="auto" class="mr-2">
                            <v-btn
                                    color="var(--color-blue)"
                                    dark
                                    size="sm"
                                    @click="onSaveModel"
                            >
                                Сохранить
                            </v-btn>
                        </v-col>
                        <v-col cols="auto">
                            <v-btn
                                    class="cancel-btn"
                                    outlined
                                    color="var(--color-3)"
                                    size="sm"
                                    @click="$bvModal.hide('modalEditModel')"
                            >
                                Отмена
                            </v-btn>
                        </v-col>
                    </v-row>
                </div>
            </template>
        </b-modal>
    </v-container>
</template>

<script>
    import {mapGetters} from 'vuex';
    import mapper from 'automapper'

    export default {
        name: "Cars",
        data() {
            return {
                selectedMark: null,
                selectedModel: null,
                searchMark: "",
                searchModel: "",
                editCarModel: {
                    id: null,
                    carModelName: null,
                    carMarkId: null,
                    yearBeg: 0,
                    yearEnd: 0
                },
                editCarMark: {
                    id: null,
                    carMarkName: null
                }

            }
        },
        created() {
            this.$store.dispatch("Cars/loadMarks").catch((err) => {
                console.log(err)
                this.$bvToast.toast(err.message, {
                    title: `Ошибка загрузки марок авто!`,
                    variant: "danger",
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 3000,
                    solid: true
                })
            });
            mapper.createMap("CarModel", "EditCarModel")
            mapper.createMap("CarMark", "EditCarMark")
        },
        computed: {
            ...mapGetters({
                carModels: "Cars/getModels",
            }),

            allMarksItems(){
                var items = this.$store.state.Cars.carMarks;
                if (items != null) {
                    return items.sort((a, b) => {
                        var nameA = a.carMarkName.toLowerCase(), nameB = b.carMarkName.toLowerCase()
                        if (nameA < nameB) //сортируем строки по возрастанию
                            return -1
                        if (nameA > nameB)
                            return 1
                        return 0
                    });
                }
                else return [];
            },

            filteredMarks() {
                var items = this.$store.state.Cars.carMarks;
                if (items != null) {
                    return items.filter((elem) => {
                        return new RegExp(this.searchMark, 'ig').test(elem.carMarkName);
                    }).sort((a, b) => {
                        var nameA = a.carMarkName.toLowerCase(), nameB = b.carMarkName.toLowerCase()
                        if (nameA < nameB) //сортируем строки по возрастанию
                            return -1
                        if (nameA > nameB)
                            return 1
                        return 0
                    });
                }
                else return [];
            },

            filteredModels() {
                if (this.selectedMark != null) {
                    var items = this.carModels(this.selectedMark.id)
                    if (items != null) {
                        return items.filter((elem) => {
                            return new RegExp(this.searchModel, 'ig').test(elem.carModelName);
                        }).sort((a, b) => {
                            var nameA = a.carModelName.toLowerCase(), nameB = b.carModelName.toLowerCase()
                            if (nameA < nameB) //сортируем строки по возрастанию
                                return -1
                            if (nameA > nameB)
                                return 1
                            return 0
                        });
                    }
                    else return [];
                }
                else return [];
            },
        },
        methods: {
            showAddMarkModal() {
                this.resetMark();
                this.$bvModal.show('modalAddMark')
            },

            showEditMarkModal() {

                this.$bvModal.show('modalEditMark')
            },

            showAddModelModal() {
                this.resetModel();
                this.$bvModal.show('modalAddModel')
            },

            showEditModelModal() {
                this.$bvModal.show('modalEditModel')
            },

            resetMark() {
                for (var key in this.editCarMark) {
                    this.editCarMark[key] = null;
                }
            },

            resetModel() {
                for (var key in this.editCarModel) {
                    this.editCarModel[key] = null;
                }
                if(this.selectedMark!=null){
                    this.editCarModel.carMarkId=this.selectedMark.id
                }
            },

            onSaveMark() {
                //если есть id, то редактируем запись, иначе добавляем
                if (this.editCarMark.id != null) {
                    try {
                        this.$store.dispatch('Cars/editMark', this.editCarMark).then(() => {
                                this.$bvToast.toast("Марка успешно обновлена", {
                                    variant: "success",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            }
                        ).catch(err => {
                            this.$bvToast.toast(err.message, {
                                title: `Ошибка обновления марки авто!`,
                                variant: "danger",
                                toaster: 'b-toaster-bottom-right',
                                autoHideDelay: 3000,
                                solid: true
                            })
                        });
                    } catch (e) {
                        console.log(e)
                    }
                    this.$bvModal.hide('modalEditMark')
                }
                else {
                    try {
                        this.$store.dispatch('Cars/addMark', this.editCarMark).then(() => {
                            this.$bvToast.toast("Марка успешно добавлена", {
                                variant: "success",
                                toaster: 'b-toaster-bottom-right',
                                autoHideDelay: 3000,
                                solid: true
                            })
                        }).catch(err => {
                            this.$bvToast.toast(err.message, {
                                title: `Ошибка добавления марки авто!`,
                                variant: "danger",
                                toaster: 'b-toaster-bottom-right',
                                autoHideDelay: 3000,
                                solid: true
                            })
                        });
                    } catch (e) {
                        console.log(e)
                    }
                    this.$bvModal.hide('modalAddMark')
                }
            },

            onSaveModel() {
                //если есть id, то редактируем запись, иначе добавляем
                if (this.editCarModel.id != null) {
                    try {
                        this.$store.dispatch('Cars/editModel', this.editCarModel).then(() => {
                                this.$bvToast.toast("Модель успешно обновлена", {
                                    variant: "success",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            }
                        ).catch(err => {
                            this.$bvToast.toast(err.message, {
                                title: `Ошибка обновления модели авто!`,
                                variant: "danger",
                                toaster: 'b-toaster-bottom-right',
                                autoHideDelay: 3000,
                                solid: true
                            })
                        });
                    } catch (e) {
                        console.log(e)
                    }
                    this.$bvModal.hide('modalEditModel')
                }
                else {
                    try {
                        this.editCarModel.carMarkId = this.selectedMark.id;
                        this.$store.dispatch('Cars/addModel', this.editCarModel).then(() => {
                            this.$bvToast.toast("Модель успешно добавлена", {
                                variant: "success",
                                toaster: 'b-toaster-bottom-right',
                                autoHideDelay: 3000,
                                solid: true
                            })
                        }).catch(err => {
                            this.$bvToast.toast(err.message, {
                                title: `Ошибка добавления модели авто!`,
                                variant: "danger",
                                toaster: 'b-toaster-bottom-right',
                                autoHideDelay: 3000,
                                solid: true
                            })
                        });
                    } catch (e) {
                        console.log(e)
                    }
                    this.$bvModal.hide('modalAddModel')
                }
            },

            deleteMark() {
                this.$bvModal.msgBoxConfirm('Вы действительно хотите удалить запись?', {
                    title: 'Подтверждение',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Удалить',
                    cancelTitle: 'Отмена',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                    .then(value => {
                        if (value == true) {
                            this.$store.dispatch("Cars/deleteMark", this.selectedMark.id).then(() => {
                                this.$bvToast.toast("Марка успешно удалена", {
                                    variant: "success",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            }).catch(err => {
                                this.$bvToast.toast(err.message, {
                                    title: `Ошибка удаления марки авто!`,
                                    variant: "danger",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            });
                            this.selectedMark = null;
                        }

                    })
                    .catch(err => {
                        // An error occurred
                    })
            },

            deleteModel() {
                const vm = this;
                this.$bvModal.msgBoxConfirm('Вы действительно хотите удалить запись?', {
                    title: 'Подтверждение',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Удалить',
                    cancelTitle: 'Отмена',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                    .then(value => {
                        if (value == true) {
                            this.$store.dispatch("Cars/deleteModel", {
                                markId: vm.selectedMark.id,
                                modelId: vm.selectedModel.id
                            }).then(() => {
                                vm.$bvToast.toast("Модель успешно удалена", {
                                    variant: "success",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            }).catch(err => {
                                vm.$bvToast.toast(err.message, {
                                    title: `Ошибка удаления модели авто!`,
                                    variant: "danger",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            });
                            this.selectedModel = null;
                        }
                    })
                    .catch(err => {
                        console.log(err)
                    })
            },

            markSelect(value) {
                this.selectedMark = value;
                this.selectedModel = null;

                mapper.map("CarMark", "EditCarMark", this.selectedMark, this.editCarMark)
                //если нет записи о моделях, то подтягиваем с апи
                if (this.selectedMark != null) {
                    var models = this.carModels(this.selectedMark.id)
                    if (models == null)
                        try {
                            this.$store.dispatch("Cars/loadModels", this.selectedMark.id).catch(err => {
                                this.$bvToast.toast(err.message, {
                                    title: `Ошибка загрузки моделей авто!`,
                                    variant: "danger",
                                    toaster: 'b-toaster-bottom-right',
                                    autoHideDelay: 3000,
                                    solid: true
                                })
                            })
                        } catch (e) {
                            console.log(e);
                        }
                }
            },

            modelSelect(value) {
                this.selectedModel = value;
                if(value!=null){
                    mapper.map("CarModel", "EditCarModel", this.selectedModel, this.editCarModel)
                }

            }


        }
    }
</script>

<style scoped>


    .car-header {
        width: 100%;
    }

    .car-header-toolbar, .car-header-title {
        padding: 20px 40px;
    }

    .car-header-title {
        font-style: normal;
        font-weight: 700;
        font-size: 20px;
        line-height: 40px;
    }

    .car-header-subtitle {
        color: var(--color-3);
    }

    .car-header-toolbar {
        display: flex;
    }

    .car-header-toolbar_add-btn, .car-header-toolbar_search-block {
        margin: auto 0;
    }

    .car-header-toolbar_search-block {
        margin-left: 30px;
        width: 100%;
    }
    .selected-item.selected-item{
        background-color: var(--color-blue);
        color:white;
    }

    .selected-item.selected-item .item-action{
        color:white;
    }


</style>
